import { ApolloClient, InMemoryCache, createHttpLink, from } from '@apollo/client';
import { createAuthLink, createErrorLink } from './apollo-links';
import { typePolicies } from './apollo-cache-config';

const httpLink = createHttpLink({
  uri: import.meta.env.VITE_GRAPHQL_API_URL || 'http://localhost:8010/graphql-v2/',
});

const authLink = createAuthLink();
const errorLink = createErrorLink();

export const apolloClient = new ApolloClient({
  // Link order is important: authLink adds token, errorLink handles errors, httpLink makes request
  link: from([authLink, errorLink, httpLink]),
  cache: new InMemoryCache({ typePolicies }),
  defaultOptions: {
    watchQuery: {
      errorPolicy: 'all',
    },
    query: {
      errorPolicy: 'all',
    },
  },
});
